import { Paper } from '@material-ui/core';
import CustomCheckbox from 'components/CustomCheckbox';
import CustomTextField from 'components/Input/CustomTextField';
import React, { useEffect, useState } from 'react';
import { SHyperLink } from 'style/CommonStyledComponent';
import styled from 'styled-components/macro';
import { siteInfoLookup, studyInfoLookup } from 'utility/formLookup';
import { produce } from 'utility/general';
import CompareModal from 'components/Application/Amendment/CompareModal';
import moment from 'moment';

const SLayout = styled.div`
    border: 2px solid #808080;
    display: flex;
`;

const SNumberLayout = styled.div`
    width: 30px;
    flex-shrink: 0;
    border-right: 2px solid #808080;
    display: flex;
    justify-content: center;
    padding-top: 5px;
`;

const STypeLayout = styled.div`
    width: 200px;
    flex-shrink: 0;
    padding: 5px;
    border-right: 2px solid #808080;
    font-weight: bold;
    background: #f9f9f9;
    display: flex;
    align-items: center;
`;

const SValueContainer = styled.div`
    flex: 1;
    display: flex;
    padding: 5px;
    align-items: center;
`;

const SRowContainer = styled.div`
    border-bottom: 2px solid #808080;
    flex-grow: 1;
    display: flex;
`;

const SContentLayout = styled.div`
    flex-grow: 1;
`;

const SValueLayout = styled.div`
    flex: 1;
    padding: 5px;
    display: flex;
    align-items: center;
`;

const STitle = styled.div`
    flex: 1;
    flex-shrink: 0;
    padding: 5px;
    background: #f9f9f9;
    font-weight: bold;
    font-size: 14px;
`;

const SAmendmentValue = styled.div`
    flex: 1;
    flex-shrink: 0;
    padding: 5px;
`;

const SProposedBySection = styled.div`
    flex: 1;
    border-right: 2px solid #808080;
    display: flex;
`;

const SRiskSection = styled.div`
    flex: 1;
    display: flex;
`;

const ChangeHistory = ({
    index = 1,
    applicationDetail,
    data = {},
}) => {
    const [isCompareShow, setCompareShow] = useState(false);
    const [amendInstitution, setAmendInstitution] = useState('');

    const getValue = (formattedValue) => {
        const result = formattedValue.split('~:(');
        return result;
    };

    const getTypeDisplay = (type) => {
        if (type !== 'Y') {
            return 'Site Info';
        } else if (type === 'Y') {
            return 'Study Info';
        } else {
            return type;
        }
    };

    const shouldCompareShow = () => {
        const isStudyType = data.studyInfo === 'Y';
        
        if (isStudyType) {
            return studyInfoLookup()[data.questionNo]?.isTextArea;
        } else {
            return siteInfoLookup()[data.questionNo]?.isTextArea;
        }
    };

    useEffect(() => {
        if (applicationDetail?.applicationForm?.amendInstitution) {
            setAmendInstitution(applicationDetail?.applicationForm?.amendInstitution);
        }
    }, [applicationDetail]);

    return (
        <Paper>
            <SLayout>
                {isCompareShow && (
                    <CompareModal
                        originalText={data?.previousValue}
                        changedText={data?.currentValue}
                        onClose={() => setCompareShow(false)}
                    />
                )}
                <SNumberLayout>{index}.</SNumberLayout>
                <SContentLayout>
                    <SRowContainer>
                        <STypeLayout>Study Info/Site Info</STypeLayout>
                        <SValueContainer>
                            {amendInstitution !== ''
                                ? `${getTypeDisplay(data.studyInfo) + ' (' + amendInstitution + ')'}`
                                : `${getTypeDisplay(data.studyInfo)}`}
                        </SValueContainer>
                    </SRowContainer>
                    <SRowContainer>
                        <STypeLayout>Field Name/Document Name</STypeLayout>
                        <SValueContainer>{data?.questionDesc}</SValueContainer>
                    </SRowContainer>
                    <SRowContainer>
                        <STitle style={{ borderRight: '2px solid #808080' }}>Current condition</STitle>
                        <STitle style={{ display: 'flex' }}>
                            Amendment
                            {shouldCompareShow() && (
                                <SHyperLink style={{ marginLeft: 10 }} onClick={() => setCompareShow(true)}>
                                    (Compare)
                                </SHyperLink>
                            )}
                        </STitle>
                    </SRowContainer>
                    <SRowContainer>
                        <SAmendmentValue style={{ borderRight: '2px solid #808080' }}>
                            {data?.previousValue &&
                                getValue(data.previousValue).map((item, index) => {
                                    return (
                                        <div key={index} style={{ padding: '2px 0', wordBreak: 'break-all' }}>
                                            {item}
                                        </div>
                                    );
                                })}
                        </SAmendmentValue>
                        <SAmendmentValue>
                            {data?.currentValue &&
                                getValue(data.currentValue).map((item, index) => {
                                    return (
                                        <div key={index} style={{ padding: '2px 0', wordBreak: 'break-all' }}>
                                            {item}
                                        </div>
                                    );
                                })}
                        </SAmendmentValue>
                    </SRowContainer>

                    <SRowContainer>
                        <SProposedBySection>
                            <STypeLayout>Proposed by</STypeLayout>
                            <SValueContainer>
                                {data?.updateBy}
                            </SValueContainer>
                        </SProposedBySection>
                        <SRiskSection>
                            <STypeLayout style={{ width: 200 }}>Update Date Time</STypeLayout>
                            <SValueLayout>
                                {moment(data?.updateDtm).format('YYYY-MM-DD HH:mm:ss')}
                            </SValueLayout>
                        </SRiskSection>
                    </SRowContainer>
                </SContentLayout>
            </SLayout>
        </Paper>
    );
};

export default ChangeHistory;
